// Attaches the logged-in user's session token to every fetch() call aimed at
// the API, without having to touch every individual fetch() call site across
// the app (there are dozens, scattered across many components). Import this
// once, as early as possible (see src/index.js), before anything else fetches.
//
// The backend now requires `Authorization: Bearer <token>` on every route
// except login/signup/otp/reset-password (see backend/auth.js) — without this,
// every existing fetch() call in the app would start failing with 401s.

const API_ORIGIN = "https://dshb-deposits.its.uiowa.edu";

const nativeFetch = window.fetch.bind(window);

window.fetch = async (input, init = {}) => {
  const url = typeof input === "string" ? input : input?.url || "";
  const isApiCall = url.startsWith(API_ORIGIN);

  if (isApiCall) {
    const token = sessionStorage.getItem("authToken");
    if (token) {
      init = {
        ...init,
        headers: {
          ...(init.headers || {}),
          Authorization: `Bearer ${token}`,
        },
      };
    }
  }

  const response = await nativeFetch(input, init);

  // Session expired or was never valid — every call would otherwise fail
  // silently with confusing "failed to fetch X" toasts. Bounce to login
  // instead of leaving the user stuck on a half-broken page. Skip login
  // itself so a wrong password shows its real error, not a redirect.
  if (isApiCall && response.status === 401 && !url.includes("/api/login")) {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("authToken");
    if (window.location.pathname !== "/") {
      window.location.assign("/");
    }
  }

  return response;
};
